<template>
  <el-dialog
    width="320px"
    top="10%"
    :visible.sync="options.visible"
    append-to-body
    class="tip-messages"
  >
    <iframe
      style="position: absolute; z-index: -1; width: 100%; height: 100%; top: 0;left:0;scrolling:no;"
      frameborder="0"
    ></iframe>
    <div class="tip-msg-box">
      <center v-if="options.showImg">
        <img v-bind:src="options.imgSrc" width="96px" />
      </center>
      <h3 class="Font_size_24 text-center" :class="options.msgClass">
        {{ options.msg }}
      </h3>
      <p class="Font_size_16 text-center" v-if="options.showDesp">
        {{ options.desp }}
      </p>
      <div class="text-center">
        <!-- :type="options.btnType" -->
        <el-button :type="options.btnType" round @click="handleAction('yes')">{{
          options.btnTitle
        }}</el-button>
        <el-button
          :type="options.btnCancelType"
          v-if="options.showCancelBtn"
          round
          @click="handleAction('no')"
          style="margin-left:10px;"
          >{{ options.btnCancelTitle }}</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      options: {
        showType: 0, // 0：表单提交成功 1：表单提交失败 2：自定义样式
        showImg: true,
        imgSrc: "../../../static/img/tijiao.png",
        visible: false,
        msg: "",
        msgClass: "tip-text-color-green",
        showDesp: false,
        desp: "",
        btnType: "greens",
        btnTitle: "确 定",
        showCancelBtn: false,
        btnCancelType: "orgin",
        btnCancelTitle: "取 消"
      },
      promiseStatus: null
    };
  },

  watch: {},
  methods: {
    //外界调用，显示插件。
    confirm() {
      let _this = this;
      this.options.visible = true;
      return new Promise((resolve, reject) => {
        //将两个处理对象存储，等待被调用。
        _this.promiseStatus = { resolve, reject };
      });
    },
    handleAction(action) {
      this.options.visible = false;
      if (action == "yes") {
        this.promiseStatus && this.promiseStatus.resolve(true);
      } else {
        this.promiseStatus && this.promiseStatus.reject(false);
      }
    }
  },

  mounted() {
    //console.log(this.userOptions);
    if (this.options.showType == 1) {
      this.options.imgSrc = "../../../../static/img/del.png";
      this.options.msg = "糟糕，提交失败！";
      this.options.msgClass = "tip-text-color-red";
      this.options.desp = "您可以稍后重新操作";
      this.options.btnType = "reds";
      this.options.btnTitle = "确 定";
    } else if (this.options.showType == 3) {
      this.options.imgSrc = "../../../static/img/wenhao.png";
      this.options.msgClass = "tip-text-color-blue";
      this.options.btnType = "blues";
      // this.options.msg = "是否删除此条数据？";
      // this.options.desp = "删除后不可恢复";
      this.options.showCancelBtn = true;
    } else if (this.options.showType == 2) {
      this.options.imgSrc = "../../../static/img/gantanhao.png";
      this.options.msg = "请选择一条数据！";
      this.options.msgClass = "tip-text-color-yellow";
      this.options.desp = "数据未选或选择多条";
      this.options.btnType = "yellows";
      this.options.showCancelBtn = false;
    } else if (this.options.showType == 4) {
      this.options.imgSrc = "../../../../static/img/del.png";
      //this.options.msg = "糟糕，提交失败！";
      this.options.msgClass = "tip-text-color-red";
      //this.options.desp = "您可以稍后重新操作";
      this.options.btnType = "reds";
      this.options.btnTitle = "确 定";
    } 
  }
};
</script>

<style scoped>
.confirm-wrap {
  background-color: #fff;
  position: absolute;
  z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// src/components/common/confirm.vue